import { Box, Skeleton } from '@/primitives';
import { slate } from '@/lib/colours';

interface Props {
  isBrief?: boolean;
  landing?: boolean;
}

export default function NewsCardSkeleton({ isBrief, landing }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isBrief ? 'row' : 'column',
        borderRadius: landing ? '14px' : 0,
        maxWidth: { xs: 'unset', md: '378px' },
        backgroundColor: landing ? slate[900] : 'transparent',
        border: landing ? `1px solid ${slate[800]}` : 'none',
        overflow: 'hidden',
      }}
    >
      <Skeleton
        sx={{
          borderRadius: landing ? 0 : isBrief ? 0 : '12px',
          flexShrink: 0,
          height: {
            sm: isBrief ? '96px' : 'unset',
          },
          width: {
            sm: isBrief ? '96px' : '100%',
          },
          aspectRatio: isBrief
            ? '1 / 1'
            : {
                xs: '350 / 300',
                md: '336 / 260',
              },
          transform: 'none',
          bgcolor: landing ? slate[800] : undefined,
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          p: isBrief
            ? landing
              ? '16px 20px !important'
              : '0 16px !important'
            : landing
              ? '20px !important'
              : '12px 0 !important',
        }}
      >
        <Skeleton
          sx={{
            width: '75%',
            lineHeight: '24px',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '4px',
            width: '100%',
            lineHeight: isBrief ? '24px' : '20px',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
        <Skeleton
          sx={{
            mt: isBrief ? 0 : '8px',
            height: '20px',
            width: '25%',
            bgcolor: landing ? slate[800] : undefined,
          }}
        />
      </Box>
    </Box>
  );
}
